/**
 * Controls the search toggle functionality.
 * Toggles the visibility of the search form and icon states.
 */
const searchToggle = () => {
    const toggleSearch = document.querySelector('.c-search__toggle')
    const searchContainer = document.querySelector('.c-search')

    if (toggleSearch && searchContainer) {
        toggleSearch.addEventListener('click', () => {
            searchContainer.classList.toggle('is-open')
        })
    }
}

/**
 * Initializes the search control.
 */
const initSearchControl = () => {
    searchToggle()
}

export { initSearchControl }
